import Reactivate from './components/Reactivate';

export default Reactivate;